/**
 * "Cart" / "Recently viewed" tab switcher for the cart drawer header. The
 * tab triggers live inside this element; the panels they control are
 * siblings of it (both children of the same cart-items-component), so
 * panels are looked up from the parent rather than as descendants.
 */
class CartDrawerTabs extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll('[data-tab-trigger]')];
    this.panels = this.parentElement ? [...this.parentElement.querySelectorAll('[data-tab-panel]')] : [];

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.#activate(trigger.dataset.tabTrigger));
    });
  }

  /**
   * @param {string} tab
   */
  #activate(tab) {
    this.triggers.forEach((trigger) => {
      const isActive = trigger.dataset.tabTrigger === tab;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== tab;
    });
  }
}

customElements.define('cart-drawer-tabs', CartDrawerTabs);
